import axios from 'axios';
import type { ErrorEvent, EventHint } from '@sentry/react';

/**
 * NAT-2823: whether an error is an axios cancellation — a request this page cancelled on purpose
 * (its session ended, its component unmounted). The name check covers a CanceledError that lost
 * its prototype on the way to Sentry.
 */
export function isAxiosCancellation(error: unknown): boolean {
  if (axios.isCancel(error)) return true;
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { name?: unknown }).name === 'CanceledError'
  );
}

/** Sentry's beforeSend: a cancellation is not an error, so it is not reported. */
export function dropAxiosCancellations(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  return isAxiosCancellation(hint?.originalException) ? null : event;
}
